import StbSurface from "@storeblocks/surface";
import { Paragraph } from "App/global-style";
import styled from "styled-components";

export const Surface = styled(StbSurface)`
  padding: ${({ theme }) => theme.spacing.md};
`;

export const BoldParagraph = styled(Paragraph)`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  margin-bottom: 0;

  & > b {
    color: ${({ theme }) => theme.brandColors.primary};
  }
`;

export const LinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.lg};

  & a {
    color: ${({ theme }) => theme.brandColors.primary};
    font-size: ${({ theme }) => theme.fontSizes.sm};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    line-height: ${({ theme }) => theme.lineHeight.md};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    i {
      margin-left: 4px;
    }
  }

  & > * + * {
    margin-top: ${({ theme }) => theme.spacing.md};
  }
`;

export const FlexContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  & > *:first-child {
    margin-right: ${({ theme }) => theme.spacing.lg};
  }
`;
